import { Injectable, Optional } from '@angular/core';
import { AbstractApiController } from './abstract-api-controller';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { QrGenerateRequest } from '../model/request/qr-generate.request';

@Injectable()
export class AdminQrGenerateApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public generate(request: QrGenerateRequest) {
    return this.http.post<any>(
      this.baseUrl + '/api/cf/administration/qr-generate'
      , request
      , {headers: this.getAuthHeaders()}
    );
  }

  public generateForIban(request: QrGenerateRequest) {
    return this.http.post<any>(
      this.baseUrl + '/api/cf/administration/qr-generate-for-iban'
      , request
      , {headers: this.getAuthHeaders()}
    );
  }
}
